import {Injectable} from '@angular/core';
import {
    MeshPhongMaterial,
    Texture,
    Object3D,
    Mesh, Material
} from 'three';
import { Patient } from 'projects/persistence/src/public-api';

@Injectable({
    providedIn: 'root'
})
export class ContainerService {

    // painting/calculation ----------------------------------------------------------------------------------------------------------------

    public readonly textureRes = 1024;

    private _materialTexture: Material;
    private _textureCanvas = document.createElement('canvas');
    private _texture: Texture;

    private _width: number;
    private _height: number;
    private _canvasWidth: number;
    private _canvasHeight: number;

    private _lassoSelectionObject = new Object3D();
    private _faceNeighbours: Map<number, Array<number>>;

    // image -------------------------------------------------------------------------------------------------------------------------------

    private _imagePlane = new Object3D();
    // TODO mwimmer remove
    private _helpPlane = new Object3D();
    private _imageAligned = false;

    // patient/shape -----------------------------------------------------------------------------------------------------------------------

    private _patient: Patient;
    private _targetModel: Mesh;
    private _colorCodingTargetModel: Mesh;
    private _targets: any;
    private _targetInfluences: any;
    private _targetOffsets: any;

    // scene -------------------------------------------------------------------------------------------------------------------------------

    // public reload = true;
    private _loadingStatus = 0;

    private _renderGroup = new Object3D();
    private _polyPaintGroup = new Object3D();
    private _material: MeshPhongMaterial;

    private _pointSize = 0.15;

    constructor() {
    }

    // -------------------------------------------------------------------------------------------------------------------------------------
    // -------------------------------------------------------------------------------------------------------------------------------------

    // painting/calculation ----------------------------------------------------------------------------------------------------------------

    get materialTexture(): Material {
        return this._materialTexture;
    }

    set materialTexture(value: Material) {
        this._materialTexture = value;
    }

    get textureCanvas(): HTMLCanvasElement {
        return this._textureCanvas;
    }

    get texture(): Texture {
        return this._texture;
    }

    set texture(value: Texture) {
        this._texture = value;
    }


    get width(): number {
        return this._width;
    }

    set width(value: number) {
        this._width = value;
    }

    get height(): number {
        return this._height;
    }

    set height(value: number) {
        this._height = value;
    }


    get canvasWidth(): number {
        return this._canvasWidth;
    }

    set canvasWidth(value: number) {
        this._canvasWidth = value;
    }


    get canvasHeight(): number {
        return this._canvasHeight;
    }

    set canvasHeight(value: number) {
        this._canvasHeight = value;
    }


    get lassoSelectionObject(): Object3D {
        return this._lassoSelectionObject;
    }

    set lassoSelectionObject(value: Object3D) {
        this._lassoSelectionObject = value;
    }


    get faceNeighbours() {
        return this._faceNeighbours;
    }

    set faceNeighbours(value: Map<number, Array<number>>) {
        this._faceNeighbours = value;
    }

    // image -------------------------------------------------------------------------------------------------------------------------------

    get imagePlane(): Object3D {
        return this._imagePlane;
    }

    set imagePlane(value: Object3D) {
        this._imagePlane = value;
    }


    get helpPlane(): Object3D {
        return this._helpPlane;
    }

    set helpPlane(value: Object3D) {
        this._helpPlane = value;
    }

    // get resFactor(): number {
    //     return this._resFactor;
    // }
    //
    // set resFactor(value: number) {
    //     this._resFactor = value;
    // }

    get imageAligned(): boolean {
        return this._imageAligned;
    }

    set imageAligned(value: boolean) {
        this._imageAligned = value;
    }

    // patient/shape -----------------------------------------------------------------------------------------------------------------------

    get patient(): Patient {
        return this._patient;
    }

    set patient(value: Patient) {
        this._patient = value;
    }


    get targetModel(): Mesh {
        return this._targetModel;
    }

    set targetModel(value) {
        this._targetModel = value;
    }


    get colorCodingTargetModel() {
        return this._colorCodingTargetModel;
    }

    set colorCodingTargetModel(value) {
        this._colorCodingTargetModel = value;
    }


    get targets() {
        return this._targets;
    }

    set targets(value) {
        this._targets = value;
    }


    get targetInfluences() {
        return this._targetInfluences;
    }

    set targetInfluences(value) {
        this._targetInfluences = value;
    }


    get targetOffsets() {
        return this._targetOffsets;
    }

    set targetOffsets(value) {
        this._targetOffsets = value;
    }

    // scene -------------------------------------------------------------------------------------------------------------------------------

    get loadingStatus(): number {
        return this._loadingStatus;
    }

    set loadingStatus(value: number) {
        this._loadingStatus = value;
    }


    get renderGroup(): Object3D {
        return this._renderGroup;
    }

    set renderGroup(value: Object3D) {
        this._renderGroup = value;
    }


    get polyPaintGroup(): Object3D {
        return this._polyPaintGroup;
    }

    set polyPaintGroup(value: Object3D) {
        this._polyPaintGroup = value;
    }


    get material(): MeshPhongMaterial {
        return this._material;
    }

    set material(value: MeshPhongMaterial) {
        this._material = value;
    }

    get pointSize(): number {
        return this._pointSize;
    }

}
